// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont_info_cis {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.top_info_cis {
  position: relative;
  display: block;
  height: 35%;
  width: 100%;
}
.row_info_cis {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: start;
  align-items: center;
}
.row_info_cis:nth-child(odd) {
  background-color: #f8f9fa;
}
.row_info_cis:nth-child(even) {
  background-color: #eeeeee;
}
.title-info_cis {
  position: relative;
  width: 13%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  color: #003757d3;
  font-size: large;
}
.txt-info_cis {
  position: relative;
  width: 87%;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #414141;
  font-size: medium;
}
.cel_row_info_cis {
  position: relative;
  display: flex;
  width: 25%;
  height: 100%;
}
.cel_row_info_cis:nth-child(even) {
  background-color: #f8f9fa;
}
.cel_row_info_cis:nth-child(odd) {
  background-color: #eeeeee;
}

.body_info_cis {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 95%;
}

.actBlanco {
  height: 4vh !important;
}


.info-mantenimiento-action:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/config-components/Criticidad/styles/InfoPortafolio.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,eAAe;AACjB","sourcesContent":[".cont_info_cis {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.top_info_cis {\r\n  position: relative;\r\n  display: block;\r\n  height: 35%;\r\n  width: 100%;\r\n}\r\n.row_info_cis {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 20%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n}\r\n.row_info_cis:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n.row_info_cis:nth-child(even) {\r\n  background-color: #eeeeee;\r\n}\r\n.title-info_cis {\r\n  position: relative;\r\n  width: 13%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bolder;\r\n  color: #003757d3;\r\n  font-size: large;\r\n}\r\n.txt-info_cis {\r\n  position: relative;\r\n  width: 87%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  color: #414141;\r\n  font-size: medium;\r\n}\r\n.cel_row_info_cis {\r\n  position: relative;\r\n  display: flex;\r\n  width: 25%;\r\n  height: 100%;\r\n}\r\n.cel_row_info_cis:nth-child(even) {\r\n  background-color: #f8f9fa;\r\n}\r\n.cel_row_info_cis:nth-child(odd) {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.body_info_cis {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 95%;\r\n}\r\n\r\n.actBlanco {\r\n  height: 4vh !important;\r\n}\r\n\r\n\r\n.info-mantenimiento-action:hover {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
